/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type AssignExperimentGroupsContainer_user$ref = any;
type LogAccountCreationContainer_user$ref = any;
type LogConsentDataContainer_user$ref = any;
type LogRevenueContainer_user$ref = any;
type LogTabContainer_user$ref = any;
type NewUserTourContainer_user$ref = any;
type UserBackgroundImageContainer_user$ref = any;
type UserMenuContainer_user$ref = any;
type WidgetsContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type DashboardContainer_user$ref: FragmentReference;
export type DashboardContainer_user = {|
  +id: string,
  +joined: ?string,
  +$fragmentRefs: WidgetsContainer_user$ref & UserBackgroundImageContainer_user$ref & UserMenuContainer_user$ref & LogTabContainer_user$ref & LogRevenueContainer_user$ref & LogConsentDataContainer_user$ref & LogAccountCreationContainer_user$ref & NewUserTourContainer_user$ref & AssignExperimentGroupsContainer_user$ref,
  +$refType: DashboardContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "DashboardContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "LogTabContainer_user",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "WidgetsContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "UserBackgroundImageContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "UserMenuContainer_user",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "joined",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "LogRevenueContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "LogConsentDataContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "LogAccountCreationContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "NewUserTourContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AssignExperimentGroupsContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6f75b14eecf91e41dd4a93677a663e0c';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Dashboard/__generated__/DashboardContainer_user.graphql.js